import { useEffect, useState } from "react";

const Editable = ({ childRef, text, type, placeholder, children }) => {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || (event.key === "Escape" && !event.shiftKey)) {
      setIsEditing(false);
    }
  };

  return (
    <>
      {isEditing ? (
        <div
          className="editable editable-field"
          onBlur={() => setIsEditing(false)}
          onKeyDown={(e) => handleKeyDown(e)}
        >
          {children}
        </div>
      ) : (
        <div
          onClick={() => setIsEditing(true)}
          className={`editable ${text ? "" : "placeholder"}`}
        >
          {text || placeholder || ""}
        </div>
      )}
    </>
  );
};

export default Editable;
